// frontend/src/components/PassageiroModal/PassageiroModal.jsx

import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { createPassageiro } from '../../services/milhasService';
import { getMobileFullscreenModalProps } from '../../utils/mobileModal';

const PassageiroModal = ({ visible, onClose, onSuccess }) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    
    // Hook de mensagem interno para garantir feedback mesmo se o pai não passar
    const [messageApi, contextHolder] = message.useMessage();

    const handleFormSubmit = async (closeOnSuccess = true) => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            
            const response = await createPassageiro(values);
            
            // Exibe feedback
            messageApi.success('Passageiro cadastrado com sucesso!');
            
            // Retorna o objeto criado para o pai atualizar a lista/select
            if (onSuccess) {
                // Se o pai esperar (novoPassageiro), mandamos o objeto. 
                // Mas mantemos a lógica de fechamento aqui se o pai não controlar.
                onSuccess(response.data); 
            }

            if (closeOnSuccess) {
                form.resetFields();
                onClose();
            } else {
                form.resetFields();
                // Foco no primeiro campo para agilizar (opcional)
            }
        } catch (error) {
            const errorData = error.response?.data;
            let errorMessage = 'Erro ao salvar.';
            if (errorData && typeof errorData === 'object') {
                const firstKey = Object.keys(errorData)[0];
                errorMessage = `${firstKey}: ${errorData[firstKey][0]}`;
            }
            messageApi.error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Cadastrar Novo Passageiro"
            open={visible}
            onCancel={onClose}
            {...getMobileFullscreenModalProps(isMobile)}
            footer={[
                <Button key="back" onClick={onClose} disabled={loading} block={isMobile} size={isMobile ? 'large' : 'middle'}>Cancelar</Button>,
                <Button key="saveAndNew" onClick={() => handleFormSubmit(false)} disabled={loading} block={isMobile} size={isMobile ? 'large' : 'middle'}>Salvar e Adicionar Outro</Button>,
                <Button key="submit" type="primary" loading={loading} onClick={() => handleFormSubmit(true)} block={isMobile} size={isMobile ? 'large' : 'middle'}>Salvar</Button>,
            ]}
        >
            {contextHolder}
            <Form form={form} layout="vertical" size={isMobile ? 'large' : 'middle'}>
                <Form.Item
                    name="nome_completo"
                    label="Nome Completo"
                    rules={[{ required: true, message: 'Campo obrigatório' }]}
                >
                    <Input placeholder="Digite o nome completo do passageiro" />
                </Form.Item>
                <Form.Item
                    name="cpf"
                    label="CPF (apenas números)"
                    rules={[
                        { required: true, message: 'Campo obrigatório' },
                        { len: 11, message: 'O CPF deve conter 11 dígitos.' },
                        { pattern: /^[0-9]+$/, message: 'Digite apenas números.' }
                    ]}
                >
                    <Input maxLength={11} placeholder="Digite os 11 dígitos do CPF" />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default PassageiroModal;